'use strict'
const bundle = require('./src')

module.exports = bundle



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/index.js